/* ═══ ENTRADA DOS TÍTULOS DE BLOCO — "whisper" [2026-08-21] ══════════════════
   Referência dele: `whisper-text` (21st.dev / kauasodreas). É React + GSAP e
   aqui o tema é Liquid com JS puro, então o que veio de lá foram os PARÂMETROS,
   medidos no código do componente:
     · a revelação é POR PALAVRA, não por letra;
     · cada palavra entra com opacidade 0 → 1 e deslize de -20px na horizontal;
     · 0,5 s de percurso, escalonamento de 100 ms entre palavras;
     · dispara quando o bloco chega a 90% da altura da tela, UMA vez só.

   🪤 O TEXTO NÃO PODE DEPENDER DESTE ARQUIVO PARA EXISTIR. As palavras nascem
     invisíveis, e se o JS falhasse o título sumiria da página — defeito muito
     pior que não ter animação. Por isso a opacidade 0 mora numa classe que
     SÓ este script escreve (`.wt`): sem ele, o título fica parado e visível,
     que é o estado correto de sempre.

   🪤 E NÃO PODE DESTRUIR O `<span>` VERDE. Vários títulos já vêm com a última
     palavra colorida à mão (`Manufatura <span>Digital.</span>`, convenção
     registrada no ettore-quem-somos.liquid). Picar por `textContent` jogaria
     essa marcação fora. Aqui o corte anda pelos NÓS: texto vira palavras,
     elemento é preservado inteiro como uma palavra só.
*/
(function () {
  'use strict';

  /* 🪤 `.sec` NEM SEMPRE É O TÍTULO. Na maioria das seções ele é a CAIXA que
     embrulha título e apoio (`<div class="sec"><div class="cab2"><h2>…`), e
     em algumas ele está no próprio cabeçalho (`<h3 class="sec comp-tit">`).
     Mirando só em `.sec` eu pegava a caixa inteira: o título vinha com o
     parágrafo de apoio grudado e contava como UMA palavra — medido, os cinco
     títulos da home saíram com 1 palavra cada. Aqui a lista cobre as duas
     formas e sempre termina num cabeçalho. */
  var titulos = document.querySelectorAll(
    '.ettore .sec h2, .ettore .sec h3, .ettore h2.sec, .ettore h3.sec, .ettore .qs-h2'
  );
  if (!titulos.length) return;

  var parado = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function pica(el) {
    /* já passou por aqui, ou não tem o que picar */
    if (el.dataset.wt) return false;
    var nos = Array.prototype.slice.call(el.childNodes);
    if (!nos.length) return false;

    var frag = document.createDocumentFragment();
    var achouPalavra = false;

    nos.forEach(function (no) {
      if (no.nodeType === 3) {
        /* nó de texto: quebra em palavras, cada uma numa caixa própria */
        no.nodeValue.split(/(\s+)/).forEach(function (pedaco) {
          if (pedaco === '') return;
          if (/^\s+$/.test(pedaco)) { frag.appendChild(document.createTextNode(' ')); return; }
          var w = document.createElement('span');
          w.className = 'w';
          w.textContent = pedaco;
          frag.appendChild(w);
          achouPalavra = true;
        });
      } else if (no.nodeType === 1) {
        /* elemento (o <span> verde, um <br>, o que for): entra inteiro,
           como UMA palavra — assim a cor e qualquer marcação sobrevivem */
        var w2 = document.createElement('span');
        w2.className = 'w';
        w2.appendChild(no.cloneNode(true));
        frag.appendChild(w2);
        achouPalavra = true;
      }
    });

    if (!achouPalavra) return false;

    el.innerHTML = '';
    el.appendChild(frag);
    el.dataset.wt = '1';

    /* o escalonamento vai por índice, e o CSS multiplica por 100 ms */
    var palavras = el.querySelectorAll('.w');
    for (var i = 0; i < palavras.length; i++) {
      palavras[i].style.setProperty('--i', i);
    }

    /* ── meio preto, meio verde ──────────────────────────────────────────
       Pedido dele em 21/08: *"a gente sempre mistura a frase, meio preto meio
       verde"*, com o print de `Manufatura Digital.` como referência. Não é
       invenção: a convenção já está escrita no ettore-quem-somos.liquid —
       *"só a última palavra muda de cor"*. Aqui ela deixa de ser feita à mão
       título por título e passa a valer sozinha.

       🪤 SÓ ONDE NINGUÉM JÁ PINTOU. Título que já traz um `<span>` dentro é
         um em que a cor foi escolhida à mão (nem sempre na última palavra).
         Pintar de novo brigaria com a escolha de quem escreveu.
       ⚠️ Uma palavra só = nada de verde: "Combos" inteiro verde não é a
         mistura que ele descreveu, é outra coisa. */
    if (palavras.length > 1 && !el.querySelector('.w span, .w em, .w b')) {
      palavras[palavras.length - 1].classList.add('vd');
    }

    el.classList.add('wt');
    return true;
  }

  /* Com movimento reduzido o texto continua sendo picado (não custa nada e
     mantém o layout idêntico), mas nasce visível: o CSS desliga a transição
     e a classe `vis` entra na hora. */
  var obs = null;
  if (!parado && 'IntersectionObserver' in window) {
    obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vis');
        obs.unobserve(e.target);   /* uma vez só, como no componente original */
      });
      /* 🪤 `-10%` embaixo é o "top 90%" do GSAP: o bloco conta como visto
         quando o topo dele cruza 90% da altura da janela, e não quando
         encosta na borda. Sem isso a animação roda com o título já no meio
         da tela e a pessoa perde a entrada. */
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
  }

  Array.prototype.forEach.call(titulos, function (el) {
    if (!pica(el)) return;
    if (obs) obs.observe(el);
    else el.classList.add('vis');
  });
})();
